/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/Fields/Title",
  onChange
  
}) {
let newPatientPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'new_patient',
path: 'person.title',
})
let newPatientPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'new_patient',
path: 'person.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 data="new_patient.person.title"
 value={newPatientPersonTitleValueData}
 onChange={newPatientPersonTitleChangeData}
/>
{children}
</React.Fragment>)
}